<template>
  <div
    ref="playlistContainer"
    class="playlist-container "
    :class="{
      'tw:flex tw:w-full tw:gap-2 tw:overflow-x-auto tw:p-2 tw:border': horizon,
      'tw:flex tw:flex-col tw:gap-2 tw:px-3 tw:pb-3 tw:max-h-(--dubb-video-show-player-height) tw:border-b tw:overflow-y-auto': !horizon }"
  >
    <template v-if="horizon">
      <PlaylistItem
        v-for="item in playlist"
        :key="item.id"
        class="tw:w-[160px] tw:shrink-0"
        :class="{ 'playlist-item-current': item.id === currentVideo.id }"
        :video="item"
        :is-playing="item.id === currentVideo.id"
        @click="clickVideo(item)"
      />
    </template>
    <template v-else>
      <PlaylistItem
        v-for="item in playlist"
        :key="item.id"
        class="tw:w-[200px] tw:shrink-0"
        :class="{ 'playlist-item-current': item.id === currentVideo.id }"
        :video="item"
        :is-playing="item.id === currentVideo.id"
        @click="clickVideo(item)"
      />
    </template>
  </div>
</template>

<script>
import $ from 'jquery'
import PlaylistItem from './playlist-item.vue'

export default {
  name: 'Playlist',
  components: { PlaylistItem },
  props: {
    playlist: {
      required: true,
    },
    currentVideo: {},
    horizon: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['click-video'],
  mounted() {
    this.resizePlaylist()
  },
  methods: {
    clickVideo(video) {
      this.$emit('click-video', video)
    },
    resizePlaylist() {
      if (this.playlist.length === 0 || !this.horizon) {
        return
      }
      const $container = $(this.$refs.playlistContainer)
      const $items = $container.children()
      let targetWidth = 0
      $items.each(function () {
        targetWidth += $(this).outerWidth()
      })
      if (targetWidth < $container.width()) {
        $container.width(`${targetWidth}px`)
      }
    },
    moveCurrentToCenter() {
      const $container = $(this.$refs.playlistContainer)
      const $current = $('.playlist-item-current')
      const $firstItem = $container.children().first()

      if (this.horizon) {
        const firstItemPositionLeft = $firstItem.position().left
        const currentPositionLeft = $current.position().left
        const currentOffsetLeft = currentPositionLeft - firstItemPositionLeft
        const containerWidth = $container.width()
        const currentWidth = $current.width()
        const scrollLeft = currentOffsetLeft - containerWidth / 2 + currentWidth / 2

        $container.animate({ scrollLeft }, 500)
      }
      else {
        const firstItemPositionTop = $firstItem.position().top
        const currentPositionTop = $current.position().top
        const currentOffsetTop = currentPositionTop - firstItemPositionTop
        const containerHeight = $container.height()
        const currentHeight = $current.height()
        const scrollTop = currentOffsetTop - containerHeight / 2 + currentHeight / 2

        $container.animate({ scrollTop }, 500)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.playlist-container.playlist-vertical {
  max-height: 720px;
  position: relative;
  overflow-y: scroll;
  margin: 0 auto;

  .playlist-item {
    position: relative;
    @media (max-width: 767px) {
      width: 50%;
      padding: 3px;
    }

    .playlist-preview-wrapper {
      position: relative;
      padding-bottom: 56.25%;

      &>div {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
    }
    .playlist-preview {
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-color: #000;
    }

    .playlist-item-mask {
      background: rgba(0,0,0,0.7);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .playlist-item-title {
      position: absolute;
      text-align: center;
      color: #fff;
      background: rgba(0,0,0,0.7);
      padding: 3px;
      left: 0;
      bottom: 0;
      font-size: 12px;
      width: 100%;
    }
  }
}

.playlist-container.playlist-horizon {
  position: relative;
  overflow-x: scroll;
  display: flex;
  flex-direction: row;
  margin: 5px auto;
  width: 80%;
  @media (max-width: 480px) {
    width: 100%;
    margin-top: 10px;
  }
  border: solid 1px #ccc;
  align-items: center;

  .playlist-item {
    width: 160px;
    height: 90px;
    background-size: cover;
    background-position: center;
    margin: 5px;
    position: relative;
    cursor: pointer;
    display: flex;
    flex-shrink: 0;

    .playlist-item-mask {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0,0,0,0.7);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .playlist-item-title {
      text-align: center;
      color: #fff;
      background: rgba(0,0,0,0.7);
      align-self: flex-end;
      padding: 3px;
      width: 100%;
      &>div {
        width: 100%;
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
